import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  approved: number,
 *  submitted: number,
 *  unsubmitted: number }} ReportingStatusData
 */

const api = new Api("api/amo/reporting");

/**
 * @param {number} year Reporting year
 * @returns {Promise<AxiosResponse<ReportingStatusData>>}
 */
export const getReportingStatusData = (year) =>
  api.get(`year/${year}/status/widget`);

/**
 * @returns {Promise<AxiosResponse<number[]>>}
 */
export const getAllReportingYears = () => api.get(`years`);

/**
 * @param {number} municipalityId Municipality Id
 * @param {number} year Reporting year
 * @returns {Promise<AxiosResponse>}
 */
export const reopenReportingYear = (municipalityId, year) =>
  api.putId(`${municipalityId}/${year}/reopen`, {});
